import apiClient from "@/services/api/apiClient"
import { FeatureFlagMap } from "@/types/featureFlag"

interface EvaluateFeatureFlagsResponse {
  flags: FeatureFlagMap
}

export const evaluateFeatureFlags =
  async (): Promise<EvaluateFeatureFlagsResponse> => {
    const response = await apiClient.get<EvaluateFeatureFlagsResponse>("/feature-flags/evaluate")
    return response.data
  }
